/**
 * NMLS API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext,
} from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { NMLSLicenseRequirement } from '../model/nMLSLicenseRequirement';
// @ts-ignore
import { NMLSLicenseType } from '../model/nMLSLicenseType';
// @ts-ignore
import { NMLSLicenseTypeWithRequirements } from '../model/nMLSLicenseTypeWithRequirements';
// @ts-ignore
import { NMLSStateAgency } from '../model/nMLSStateAgency';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

@Injectable({
  providedIn: 'root',
})
export class NMLSAPIService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Gets the license requirements for the specified NMLS ID.
   * @param nmlsId The NMLS id of the license type to retrieve.
   * @param checklistType The checklist type the license type to retrieve. Possible values are: Annual Renewal, New Application, Transition, Amendment, Surrender
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public nMLSAPILicenseRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<Array<NMLSLicenseRequirement>>;
  public nMLSAPILicenseRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<NMLSLicenseRequirement>>>;
  public nMLSAPILicenseRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<NMLSLicenseRequirement>>>;
  public nMLSAPILicenseRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    if (nmlsId === null || nmlsId === undefined) {
      throw new Error(
        'Required parameter nmlsId was null or undefined when calling nMLSAPILicenseRequirementsNmlsIdChecklistTypeGet.',
      );
    }
    if (checklistType === null || checklistType === undefined) {
      throw new Error(
        'Required parameter checklistType was null or undefined when calling nMLSAPILicenseRequirementsNmlsIdChecklistTypeGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['text/plain', 'application/json', 'text/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/NMLSAPI/LicenseRequirements/${this.configuration.encodeParam({ name: 'nmlsId', value: nmlsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/${this.configuration.encodeParam({ name: 'checklistType', value: checklistType, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<NMLSLicenseRequirement>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets the license type and requirements for the specified NMLS ID.
   * @param nmlsId The NMLS id of the license type to retrieve.
   * @param checklistType The checklist type the license type to retrieve. Possible values are: Annual Renewal, New Application, Transition, Amendment, Surrender
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public nMLSAPILicenseTypeAndRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<NMLSLicenseTypeWithRequirements>;
  public nMLSAPILicenseTypeAndRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<NMLSLicenseTypeWithRequirements>>;
  public nMLSAPILicenseTypeAndRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<NMLSLicenseTypeWithRequirements>>;
  public nMLSAPILicenseTypeAndRequirementsNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    if (nmlsId === null || nmlsId === undefined) {
      throw new Error(
        'Required parameter nmlsId was null or undefined when calling nMLSAPILicenseTypeAndRequirementsNmlsIdChecklistTypeGet.',
      );
    }
    if (checklistType === null || checklistType === undefined) {
      throw new Error(
        'Required parameter checklistType was null or undefined when calling nMLSAPILicenseTypeAndRequirementsNmlsIdChecklistTypeGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['text/plain', 'application/json', 'text/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }
    //note - to check the cloudwell requirements call fail with 404 scenario
    let localVarPath = `/NMLSAPI/LicenseTypeAndRequirements/${this.configuration.encodeParam({ name: 'nmlsId', value: nmlsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/${this.configuration.encodeParam({ name: 'checklistType', value: checklistType, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<NMLSLicenseTypeWithRequirements>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets a license type for the specified NMLS ID.
   * @param nmlsId The NMLS id of the license type to retrieve.
   * @param checklistType The checklist type the license type to retrieve. Possible values are: Annual Renewal, New Application, Transition, Amendment, Surrender
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public nMLSAPILicenseTypeNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<NMLSLicenseType>;
  public nMLSAPILicenseTypeNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<NMLSLicenseType>>;
  public nMLSAPILicenseTypeNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<NMLSLicenseType>>;
  public nMLSAPILicenseTypeNmlsIdChecklistTypeGet(
    nmlsId: string,
    checklistType: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    if (nmlsId === null || nmlsId === undefined) {
      throw new Error(
        'Required parameter nmlsId was null or undefined when calling nMLSAPILicenseTypeNmlsIdChecklistTypeGet.',
      );
    }
    if (checklistType === null || checklistType === undefined) {
      throw new Error(
        'Required parameter checklistType was null or undefined when calling nMLSAPILicenseTypeNmlsIdChecklistTypeGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['text/plain', 'application/json', 'text/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/NMLSAPI/LicenseType/${this.configuration.encodeParam({ name: 'nmlsId', value: nmlsId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/${this.configuration.encodeParam({ name: 'checklistType', value: checklistType, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<NMLSLicenseType>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
  /**
   * Gets a license type for the specified NMLS ID.
   * @param nmlsId The NMLS id of the license type to retrieve.
   * @param checklistType The checklist type the license type to retrieve. Possible values are: Annual Renewal, New Application, Transition, Amendment, Surrender
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */

  public nMLSAPILicenseTypeNmlsStateAgenciesGet(
    nmlsId: string,
    checklistType?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<NMLSLicenseType>;
  public nMLSAPILicenseTypeNmlsStateAgenciesGet(
    nmlsId: string,
    checklistType?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<NMLSLicenseType>>;
  public nMLSAPILicenseTypeNmlsStateAgenciesGet(
    nmlsId: string,
    checklistType?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<NMLSLicenseType>>;
  public nMLSAPILicenseTypeNmlsStateAgenciesGet(
    nmlsId: string,
    checklistType?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    if (nmlsId === null || nmlsId === undefined) {
      throw new Error(
        'Required parameter nmlsId was null or undefined when calling nMLSAPILicenseTypeNmlsStateAgenciesGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['text/plain', 'application/json', 'text/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }
    //note - to check the the scenario cloudwell failing with 404 and also failing pulling the agency contact information api
    let localVarPath = `/NMLSAPI/stateagencies/${nmlsId}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<NMLSLicenseType>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets the state agency with the specified name.
   * @param agencyName The name of the agency to get.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public nMLSAPIStateAgenciesAgencyNameGet(
    agencyName: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<NMLSStateAgency>;
  public nMLSAPIStateAgenciesAgencyNameGet(
    agencyName: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<NMLSStateAgency>>;
  public nMLSAPIStateAgenciesAgencyNameGet(
    agencyName: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<NMLSStateAgency>>;
  public nMLSAPIStateAgenciesAgencyNameGet(
    agencyName: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    if (agencyName === null || agencyName === undefined) {
      throw new Error(
        'Required parameter agencyName was null or undefined when calling nMLSAPIStateAgenciesAgencyNameGet.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['text/plain', 'application/json', 'text/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/NMLSAPI/StateAgencies/${this.configuration.encodeParam({ name: 'agencyName', value: agencyName, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<NMLSStateAgency>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Gets the state agencies.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public nMLSAPIStateAgenciesGet(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<Array<NMLSStateAgency>>;
  public nMLSAPIStateAgenciesGet(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<NMLSStateAgency>>>;
  public nMLSAPIStateAgenciesGet(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<NMLSStateAgency>>>;
  public nMLSAPIStateAgenciesGet(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json'; context?: HttpContext },
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(['text/plain', 'application/json', 'text/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/NMLSAPI/StateAgencies`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<NMLSStateAgency>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
